import React, { useContext } from "react";
import { t } from "../../i18n";
import { FaAward, FaCertificate, FaStar, FaClock, FaUserMd } from "react-icons/fa";
import { ApplicationContext } from "../../context/GlobalState";
import "./TrustBadges.css";

const ALL_BADGES = [
  { icon: FaAward, key: "trust.topDoctor" },
  { icon: FaCertificate, key: "trust.certified" },
  { icon: FaStar, key: "trust.bestOf", brandsOnly: ["gso"] },
  { icon: FaUserMd, key: "trust.experience" },
  { icon: FaClock, key: "trust.sameDayAppts" },
];

export default function TrustBadges({ locale = "en" }) {
  const { state } = useContext(ApplicationContext);
  const brandKey = state?.brand?.brandKey || "gso";

  const badges = ALL_BADGES.filter(
    (b) => !b.brandsOnly || b.brandsOnly.includes(brandKey)
  );

  return (
    <section className="trust-badges">
      <div className="container">
        <div className="trust-badges-grid">
          {badges.map((badge, i) => (
            <div key={i} className="trust-badge">
              <badge.icon className="trust-badge-icon" />
              <span>{t(badge.key, locale)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
